import { apiClient } from 'api/apiClient';
import type { IApiResponse } from 'api/apiTypes';
import type { TProposalStatuses } from 'api/resources/overviews';

const RESOURCE = '/proposals';

export interface IProposalStatusPayload {
	id: string;
	status: TProposalStatuses;
	signature?: string;
	termsAccepted?: boolean;
}

export type TPostProposalStatusResponse = IApiResponse<Record<string, string>>;

export const postProposalStatus = async (payload: IProposalStatusPayload[]) => {
	const { data } = await apiClient.patch(RESOURCE, {
		payload,
	});

	return data;
};
